module.exports = __webpack_public_path__ + "static/media/youtube.e21ec8b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/galery/originals/youtube.svg
// module id = 118
// module chunks = 0